/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { CreateSupplierConditionRestRequest } from '../../models/create-supplier-condition-rest-request';
import { CreateSupplierConditionRestResponse } from '../../models/create-supplier-condition-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface CreateSupplierCondition$Params {
  body: CreateSupplierConditionRestRequest;
}

export function createSupplierCondition(
  http: HttpClient,
  rootUrl: string,
  params: CreateSupplierCondition$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<CreateSupplierConditionRestResponse>> {
  const rb = new RequestBuilder(rootUrl, createSupplierCondition.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateSupplierConditionRestResponse>;
    }),
  );
}

createSupplierCondition.PATH = '/supplier-condition';
